import React from 'react';

const Gallery = () => (
  <div className="p-6">
    <h2 className="text-2xl font-bold mb-2">Gallery</h2>
    <p className="text-gray-600">This is the Gallery page.</p>
  </div>
);

export default Gallery;
